const getCookie = (name, decode = true) => {
    let cookieValue = '';
    function trim(str) {
        if (typeof String.prototype.trim === 'function') {
            return String.prototype.trim.call(str);
        } else {
            return str.replace(/^\s+(.*?)\s+$/g, '$1');
        }
    }
    if (!name) {
        return cookieValue;
    }
    const cookieNameLen = name.length + 1;
    const strCookie = document.cookie;
    if (strCookie) {
        const arrCookies = strCookie.split(';');
        for (let i = 0, len = arrCookies.length; i < len; i++) {
            const cookie = trim(arrCookies[i]);
            if (cookie.substring(0, cookieNameLen) === `${name}=`) {
                cookieValue = cookie.substring(cookieNameLen);
                cookieValue = decode
                    ? decodeURIComponent(cookieValue)
                    : cookieValue;
                break;
            }
        }
    }
    return cookieValue;
};

export default getCookie;